import React from "react";
import { toast } from "react-toastify";
import { Select } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreateUserCustomer } from "../hooks";
import { useCustomers } from "../../customers/hooks";

interface IProps {
  userId: number;
  onCompleted?: () => void;
}

export const UserCustomerForm: React.FC<IProps> = ({ userId, onCompleted }) => {
  const { data } = useCustomers({ where: {} });
  const { form, submit, loading } = useCreateUserCustomer({
    defaultValues: { userId },
    onCompleted: () => {
      toast.success("Le client a été ajouté à l'utilisateur");
      onCompleted?.();
    },
  });

  return (
    <div className="card">
      <p className="label mb-2">Ajouter un client</p>
      <div className="flex gap-3 items-end">
        <Select className="w-full" {...form.register("customerId", { valueAsNumber: true })}>
          <option value="">-</option>
          {data?.customers?.results?.map((customer) => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </Select>
        <Button onClick={submit} loading={loading} disabled={loading}>
          Ajouter
        </Button>
      </div>
    </div>
  );
};
